
import React from 'react';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { SearchProviderConfig } from '@/components/job-search/search-providers/types';

interface SearchProviderSelectorProps {
  selectedProvider: string;
  onValueChange: (value: string) => void;
  availableProviders: SearchProviderConfig[];
  isLoading: boolean;
}

export const SearchProviderSelector: React.FC<SearchProviderSelectorProps> = ({
  selectedProvider,
  onValueChange,
  availableProviders,
  isLoading,
}) => {
  return (
    <div>
      <Label htmlFor="search-provider">Search Provider</Label>
      <Select value={selectedProvider} onValueChange={onValueChange} disabled={isLoading}>
        <SelectTrigger id="search-provider">
          <SelectValue placeholder="Select a provider" />
        </SelectTrigger>
        <SelectContent>
          {availableProviders.map((provider) => (
            <SelectItem key={provider.id} value={provider.id}>
              {provider.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {availableProviders.find(p => p.id === selectedProvider)?.description && (
        <p className="text-sm text-muted-foreground mt-1">
          {availableProviders.find(p => p.id === selectedProvider)?.description}
        </p>
      )}
    </div>
  );
};
